import { render, staticRenderFns } from "./AppJustification.vue?vue&type=template&id=22b08803&scoped=true&"
import script from "./AppJustification.vue?vue&type=script&lang=js&"
export * from "./AppJustification.vue?vue&type=script&lang=js&"
import style0 from "./AppJustification.vue?vue&type=style&index=0&id=22b08803&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b08803",
  null
  
)

export default component.exports